import { useAPI } from "@/hooks/useAPI";
import { UserPreferencesService } from "@/services/userPreferencesService";
import { useMemo } from "react";

export const useUserPreferencesService = () => {
  const api = useAPI("v2");
  return useMemo(() => new UserPreferencesService(api), [api]);
};
